/*****************************************************************************/
/*  File Name: treatmentTable.js                                             */
/*  Date:      July 10, 2023                                                 */
/*  Author:    Christopher Cressman                                          */
/*  Purpose:   This is the table that will show how much faster you will 
/*             pay it off if you have multiple tips 
/*
/*****************************************************************************/

import React from 'react';
import { withTranslation } from 'react-i18next';

//import styles from './styles/roi.module.scss';
//import * as TIMERANGE from '../../constants/timeRanges';
import { useROIContext } from '../../context/roiContext';
import styles from './styles/roi.module.scss';

import { BarChart, Bar, XAxis, Tooltip, Legend, ResponsiveContainer } from 'recharts';
import { convertToCurrencyChart } from '../../functions/convertCurrency';
import TierColor from './functions/getTierColor';

function ConsumerChartBlock({ t }) {
  //Load all of the default component varaibles

  const { consumerChartData, consumerChartXData } = useROIContext();

  //console.log('this is my selected Breakwodn - ---', selectedTimeBreakdown);
  //console.log('this is my consumer chart data ---->', consumerChartData);

  return (
    <div className={styles.chartBlock}>
      {consumerChartData.length > 0 ? (
        <ResponsiveContainer width='100%' height='100%'>
          <BarChart
            width={500}
            height={250}
            data={consumerChartData}
            margin={{
              top: 20,
              right: 30,
              bottom: 5,
            }}
          >
            <XAxis dataKey='name' />
            <Tooltip formatter={convertToCurrencyChart} />
            <Legend />
            {consumerChartXData.map((xAxis, i) => (
              <Bar dataKey={xAxis.key} stackId='a' fill={`${TierColor(xAxis.key)}`} key={i} />
            ))}
          </BarChart>
        </ResponsiveContainer>
      ) : (
        ''
      )}
    </div>
  );
}

export default withTranslation()(ConsumerChartBlock);
